export const initialTypeForm = {
  name: "",
  description: "",
  status: "active",
  image: "",
  imageFile: null,
};

export const normalizeTypes = (data) => {
  if (Array.isArray(data)) return data;
  return data?.data || data?.types || data?.items || [];
};

export const getTypeApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const message = data?.message || fallback;
  if (Array.isArray(data?.errors) && data.errors.length) {
    return `${message}: ${data.errors.join(", ")}`;
  }
  return message;
};

export const filterTypes = (types, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return types;

  return types.filter((type) => {
    const name = type?.name?.toLowerCase() || "";
    const key = type?.key?.toLowerCase() || "";
    const description = type?.description?.toLowerCase() || "";
    return name.includes(term) || key.includes(term) || description.includes(term);
  });
};

export const mapTypeToForm = (type) => ({
  name: type?.name || "",
  description: type?.description || "",
  status: type?.status === "inactive" ? "inactive" : "active",
  image: type?.image || "",
  imageFile: null,
});

export const validateTypeForm = (form, options = {}) => {
  const { existingTypes = [], currentId = null } = options;
  const errors = {};
  const name = form.name?.trim() || "";

  if (!name) {
    errors.name = "Type name is required.";
  } else {
    const duplicate = existingTypes.find((type) => {
      const sameName =
        String(type?.name || "")
          .trim()
          .toLowerCase() === name.toLowerCase();
      const typeId = type?._id || type?.id;
      return sameName && typeId !== currentId;
    });
    if (duplicate) {
      errors.name = "Type name already exists.";
    }
  }

  if (form.status && form.status !== "active" && form.status !== "inactive") {
    errors.status = "Status must be active or inactive.";
  }

  return errors;
};

export const buildTypeFormData = (form, options = {}) => {
  const { isEdit = false, initialForm = null } = options;
  const formData = new FormData();

  const name = form.name?.trim() || "";
  const description = form.description ?? "";
  const status = form.status === "inactive" ? "inactive" : "active";
  const imageFile = form.imageFile instanceof File ? form.imageFile : null;

  if (!isEdit) {
    formData.append("name", name);
    if (description) formData.append("description", description);
    formData.append("status", status);
    if (imageFile) formData.append("image", imageFile);
    return formData;
  }

  const initialName = initialForm?.name?.trim() || "";
  const initialDescription = initialForm?.description ?? "";
  const initialStatus =
    initialForm?.status === "inactive" ? "inactive" : "active";

  if (name !== initialName) formData.append("name", name);
  if (description !== initialDescription) {
    formData.append("description", description);
  }
  if (status !== initialStatus) formData.append("status", status);
  if (imageFile) formData.append("image", imageFile);

  return [...formData.keys()].length ? formData : null;
};
